import { render, staticRenderFns } from "./WalletName.vue?vue&type=template&id=1fd507b4&scoped=true&lang=pug"
import script from "./WalletName.vue?vue&type=script&lang=js"
export * from "./WalletName.vue?vue&type=script&lang=js"
import style0 from "./WalletName.vue?vue&type=style&index=0&id=1fd507b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd507b4",
  null
  
)

export default component.exports